import VoucherForm from "../VoucherForm";

const EditVoucher = () => <VoucherForm />;

export default EditVoucher;
